import { getNow } from '../lib/TimeUtils';
import Logger from '../tools/Logger';

const log = Logger.child({ component: 'PERFORMANCE' });

function isPeformanceApiAvailable(): boolean {
  return typeof performance !== 'undefined' && typeof performance.timing === 'object';
}

function getLoadStartTime(): number | null {
  if (isPeformanceApiAvailable()) {
    const timing = performance.timing;
    // fall back to less accurate milestones
    return timing.redirectStart || timing.fetchStart || timing.requestStart;
  }
  return null;
}

function getLoadEndTime(): number | null {
  if (isPeformanceApiAvailable()) {
    const timing = performance.timing;
    // fall back to less accurate milestones
    return (
      timing.domContentLoadedEventEnd ||
      timing.domInteractive ||
      timing.domComplete ||
      (timing as $TSFixMe).loadEventComplete
    );
  }
  return null;
}

function logPerformanceTime(label: $TSFixMe, time: $TSFixMe): void {
  const seconds = time / 1000;
  log.info(`${label} ${seconds}s`);
}

export function calculateLoadTime(endTime: $TSFixMe): number | null {
  if (isPeformanceApiAvailable()) {
    // fall back to less accurate milestones
    const startTime = getLoadStartTime();
    if (startTime && endTime && startTime < endTime) {
      return endTime - startTime;
    }
  }
  return null;
}

export function getPageLoadTime(): number | null {
  return calculateLoadTime(getLoadEndTime());
}

export function logPageLoadTime(): void {
  logPerformanceTime('Page Load', getPageLoadTime());
}

export function markPerformanceTime(label: $TSFixMe): number | null {
  const loadTime = calculateLoadTime(getNow());
  logPerformanceTime(label, loadTime);
  return loadTime;
}
